import React, { Component } from "react";
class Payment3DError extends Component {
    render() {
        return (<div className="container">
            <h1>Error</h1>
        </div>);
    }
}
export default Payment3DError;